import { Injectable } from '@angular/core';

import { HttpService } from '../http/http.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class ItemStockService {
  private apiUrl = '/itemstocks';
  private apiPlayUrl = '/play/itemstocks';
  private apiSpringUrl = '/spring/items/itemstocks';

  constructor(private http: HttpService) { }

  get(ownerId?: number): Promise<any> {
    let url = `${environment.baseUrl + sessionStorage.getItem("baseUrlCompany") + this.apiSpringUrl}`;
    if(ownerId){
      url = url+"?ownerId="+ownerId;
    }
    return this.http.get(url);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/service/item-stock/item-stock.service.ts